import React, { Component } from 'react';
import PropTypes from 'prop-types';

const MS_IN_SEC = 1000;
const SEC_IN_MIN = 60;

const withCountdown = () => WrappedComponent => {
  class WithCountdown extends Component {
    constructor(props) {
      super(props);
      this.state = {
        timeRemaining: props.minsBeforeTimeout * SEC_IN_MIN,
        interval: null
      };
    }

    startTimer() {
      if (this.state.timeRemaining > 0) {
        const interval = setInterval(this.onTick.bind(this), MS_IN_SEC);
        this.setState({ interval });
      }
    }

    clearTimer() {
      if (this.state.interval) {
        clearInterval(this.state.interval);
        this.setState({ interval: null });
      }
    }

    componentDidMount() {
      this.startTimer();
    }

    componentWillUnmount() {
      this.clearTimer();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.timerEnabled !== this.props.timerEnabled) {
        if (this.props.timerEnabled) {
          this.startTimer();
        } else {
          this.clearTimer();
        }
      }
    }

    onTick() {
      this.setState(({ timeRemaining }) => {
        const newTimeRemaining = timeRemaining - 1;
        if (newTimeRemaining === 0) {
          this.clearTimer();
          this.props.onTimerExpired();
        }
        return { timeRemaining: newTimeRemaining };
      });
    }

    render() {
      return <WrappedComponent {...this.props} timeRemaining={this.state.timeRemaining} />;
    }
  }

  WithCountdown.propTypes = {
    minsBeforeTimeout: PropTypes.number,
    onTimerExpired: PropTypes.func.isRequired,
    timerEnabled: PropTypes.bool
  };

  WithCountdown.defaultProps = {
    minsBeforeTimeout: 5,
    timerEnabled: true
  };

  WithCountdown.displayName = `withCountdown(${WrappedComponent.displayName ||
    WrappedComponent.name})`;
  return WithCountdown;
};

export { withCountdown };
